import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const raw = localStorage.getItem("nn_user");
    if (raw) {
      try { setUser(JSON.parse(raw)); } catch (e) { /* ignore */ }
    }
    setReady(true);
  }, []);

  const login = (email, name) => {
    const u = {
      email,
      name: name || email.split("@")[0].replace(/\./g, " ").replace(/\b\w/g, c => c.toUpperCase()),
      joined: new Date().toISOString(),
      city: "Brooklyn, NY",
      contributions: 12,
    };
    localStorage.setItem("nn_user", JSON.stringify(u));
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem("nn_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, ready }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
